import { Box, Dialog, FatLoadingSpinner, Heading } from '@redriverpress/system'
import StudentReferenceTask from 'Packages/tasks/components/StudentReferenceTask'
import PropTypes from 'prop-types'
import { Fragment } from 'react'
import { useQuery } from 'react-query'
import getTask from 'Common/services/tasks'

export default function ReferenceTaskDialog({
  isOpen,
  onOpenChange,
  referenceTaskId,
  openPortal,
}) {
  const { data: referenceTask, isLoading } = useQuery(
    ['reference_task', referenceTaskId],
    () => getTask(referenceTaskId),
    {
      enabled: isOpen,
    }
  )

  const PortalComponent = openPortal ? Dialog.Portal : Fragment

  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <PortalComponent>
        <Dialog.Overlay />
        <Dialog.StyledContent
          onPointerDownOutside={e => {
            e.preventDefault()
            onOpenChange(false)
          }}
        >
          <Box position='absolute' top='0.75rem' right='0.75rem'>
            <Dialog.Close />
          </Box>

          <Dialog.StyledTitle>
            <Heading as='h6' mb={0}>
              Reference
            </Heading>
          </Dialog.StyledTitle>
          <Box mt={[3, null, 4]}>
            <Box my={3}>
              {isLoading && (
                <Box display='flex' justifyContent='center'>
                  <FatLoadingSpinner />
                </Box>
              )}
              {referenceTask && (
                <StudentReferenceTask task={referenceTask} isNewLayout />
              )}
            </Box>
          </Box>
        </Dialog.StyledContent>
      </PortalComponent>
    </Dialog.Root>
  )
}

ReferenceTaskDialog.defaultProps = {
  openPortal: true,
}

ReferenceTaskDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  referenceTaskId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  openPortal: PropTypes.bool,
}
